import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import LoginView from '@/views/AdminPanel/LoginView.vue';
import AdminPanel from '@/views/AdminPanel/AdminPanelView.vue';
import ServicesView from '@/views/AdminPanel/ServicesView.vue';
import EventsView from '@/views/AdminPanel/EventsView.vue';
import NotificationManager from '@/components/admin-dashboard/NotificationManager.vue';
import BlogView from '@/views/BlogView.vue';
import BlogListingView from '@/views/BlogListingView.vue';
import HomeView from '@/views/HomeView.vue';
import PrivacyPolicyView from '../views/PrivacyPolicyView.vue';
import BlogsManagerView from '@/views/AdminPanel/BlogsManagerView.vue';
import UserBaseCounter from '@/views/UserBaseCounterTest.vue';
import OrdersDashboard from '@/views/AdminPanel/OrdersDashboard.vue';
import PartnerSlotsDashboard from '@/views/AdminPanel/PartnerSlotsDashboard.vue';
import PartnerDashboard from '@/views/AdminPanel/PartnerDashboard.vue';
import PartnersOverview from '@/views/AdminPanel/PartnersOverview.vue';
import KPIsDashboard from '@/views/AdminPanel/KPIsDashboard.vue';
import WorkspaceView from '@/views/AdminPanel/WorkspaceView.vue';
import StoreRedirect from '@/views/StoreRedirect.vue';
import { auth } from '@/config/firebase';
import { onAuthStateChanged } from 'firebase/auth';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/admin-dashboard/login',
    name: 'admin-login',
    component: LoginView,
  },
  {
    path: '/admin-dashboard',
    name: 'admin-dashboard',
    component: AdminPanel,
  },
  {
    path: '/admin-dashboard/services',
    name: 'admin-dashboard-services',
    component: ServicesView,
  },
  {
    path: '/admin-dashboard/events',
    name: 'admin-dashboard-events',
    component: EventsView,
  },
  {
    path: '/admin-dashboard/orders',
    name: 'admin-dashboard-orders',
    component: OrdersDashboard,
  },
  {
    path: '/admin-dashboard/availability',
    name: 'admin-dashboard-availability',
    component: PartnerSlotsDashboard,
  },
  {
    path: '/admin-dashboard/notification-manager',
    name: 'notification-manager',
    component: NotificationManager,
  },
  {
    path: '/admin-dashboard/blog-manager',
    name: 'blog-manager',
    component: BlogsManagerView,
  },
  {
    path: '/admin-dashboard/partner-dashboard',
    name: 'partner-dashboard',
    component: PartnerDashboard,
  },
  {
    path: '/admin-dashboard/partners-overview',
    name: 'partners-overview',
    component: PartnersOverview,
  },
  {
    path: '/admin-dashboard/kpis',
    name: 'admin-dashboard-kpis',
    component: KPIsDashboard,
  },
  {
    path: '/admin-dashboard/workspace',
    name: 'admin-dashboard-workspace',
    component: WorkspaceView,
  },
  {
    path: '/privacy-policy',
    name: 'privacy policy',

    component: PrivacyPolicyView,
  },
  { path: '/blog/:slug', component: BlogView },
  { path: '/blog', component: BlogListingView },
  { path: '/user-counter', component: UserBaseCounter },
  { path: '/download-app', name: 'get-app', component: StoreRedirect },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Secure routes
const adminRoutes = [
  'admin-dashboard',
  'admin-dashboard-services',
  'admin-dashboard-events',
  'admin-dashboard-orders',
  'admin-dashboard-availability',
  'admin-dashboard-kpis',
  'admin-dashboard-workspace',
  'notification-manager',
  'partners-overview',
];
const partnerRoutes = ['partner-dashboard'];

const assistantRoutes = ['blog-manager'];

router.beforeEach(async (to, from, next) => {
  // const publicPages = ['admin-login', 'home', 'privacy policy', undefined];
  const requiresAuth = adminRoutes.includes(to.name as string)
    || partnerRoutes.includes(to.name as string)
    || assistantRoutes.includes(to.name as string);

  if (!requiresAuth) {
    return next();
  }

  // Check Firebase Auth
  let isAuthenticated = false;
  await new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      isAuthenticated = !!user;
      unsubscribe();
      resolve(null);
    });
  });

  if (!isAuthenticated) {
    return next({ name: 'admin-login' });
  }

  // Check role
  const userRole = localStorage.getItem('userRole');
  // console.log('userRole', userRole);
  // let roles: string[] = [];
  // try {
  //   const raw = localStorage.getItem('roles');
  //   if (raw) {
  //     const parsed = JSON.parse(raw);
  //     if (Array.isArray(parsed)) roles = parsed;
  //   }
  // } catch (_) {
  //   // ignore parse errors
  // }

  // // If user is a team-member, allow ONLY the workspace route
  // if (roles.includes('team-member')) {
  //   if (to.name !== 'admin-dashboard-workspace') {
  //     return next({ name: 'admin-dashboard-workspace' });
  //   }
  //   return next();
  // }

  if (adminRoutes.includes(to.name as string) && userRole !== 'admin') {
    if (userRole === 'partner') return next({ name: 'partner-dashboard' });
    if (userRole === 'assistant') return next({ name: 'blog-manager' });
  }
  // if (assistantRoutes.includes(to.name as string) && userRole === 'assistant') {
  //   return next();
  // }
  // if (partnerRoutes.includes(to.name as string) && userRole !== 'partner') {
  //   return next({ name: 'admin-dashboard' });
  // }

  return next();
});

export default router;
